<script>
import {ElMessage, ElNotification} from "element-plus";
import http from "@/http";

export default {
  name: "KindergardenForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        organization_id: null,
        board_id: null,
        quarter_id: null,
        location: null,
        power: 0,
        initial_value: 0,
        description: null,
        last_repaired_year: null,
        type_of_work: null,
        technical_position: null,
        images: []
      },
      boards: [],
      quarters: [],
      organizationList: [],
      region_id: null,
      district_id: null,
      districts: [],
      regions: [],

      workTypes: [
        {value: "NEW_CONSTRUCTION", label: "Yangi qurilish"},
        {value: "PERFECT_REPAIR", label: "Mukammal ta'mir"},
        {value: "RECONSTRUCTION", label: "Rekonstruktsiya"},
      ],
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
      rules: {
        type_of_work: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        board_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        quarter_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        technical_position: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      }
    }
  },
  methods: {
    uploadImg(event) {
      this.loading = true;
      const files = event.target.files
      const imagesList = new FormData()
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      for (const img of files) {
        this.loading = true
        imagesList.append('file', img)
        http
            .post(url, imagesList, {
              headers: {
                Authorization: this.$store.state.accessToken,
                "Content-Type": "multipart/form-data",
              },
            }).then(({data}) => {
          this.form.images.push(data.hashId);
        })
            .catch((err) => {
              ElMessage.error(
                  err.response.data.message || `Hatolik qayta urinib ko'ring`
              );
            })
            .finally(() => {
              this.loading = false
            })
      }
    },
    getBoards() {
      this.loading = true;
      http({url: `api/v1/boards`, params: {type: 'KINDERGARDEN', status: 1}})
          .then(({data}) => {
            this.boards = data.boards;
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onChangeRegion() {
      this.districts = [];
      this.district_id = null;
      this.quarters = [];
      this.getDistricts();
    },
    getRegions() {
      this.loading = true;
      this.$http
          .get(`api/v1/regions`)
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          })
          .finally(() => this.loading = false);
    },
    getDistricts() {
      this.loading = true;
      this.$http
          .get(`api/v1/districts`, {
            params: {
              region_id: this.region_id,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          }).finally(() => this.loading = false);
    },
    onChangeDistrict() {
      this.quarters = [];
      this.form.quarter_id = null;
      this.getOrganizations();
      this.getQuarters()
    },
    getQuarters() {
      this.loading = true;
      this.$http
          .get(`api/v1/quarters?district_id=${this.district_id}`)
          .then(({data}) => {
            this.quarters = data.quarters;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          }).finally(() => this.loading = false);
    },
    getOrganizations() {
      this.loading = true;
      this.$http
          .get(
              `api/v1/organizations?district_id=${this.district_id}&organization_type=KINDERGARDEN`
          )
          .then((res) => {
            this.organizationList = res.data?.organizations;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      if (!this.form.images?.length) {
        ElNotification.error({message: "Rasim yuklash majburiy"});
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.last_repaired_year = parseInt(this.form.last_repaired_year)
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/kindergardens/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/kindergardens", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    },
    handleImageUpload() {
      const fileInputId = document.getElementById('fileInputRef');
      fileInputId.click()
    },
    onClickRemove(index) {
      this.form.images.splice(index, 1);
    },
    getKindergarden() {
      this.loading = true;
      this.$http
          .get(`api/v1/kindergardens/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            if (!data.images) {
              this.form.images = []
            }
            this.form.last_repaired_year = data.last_repaired_year?.toString();
            this.region_id = data.region_id;

            this.getRegions()

            if (data.region_id) {
              this.district_id = data.district_id;
              this.getDistricts()
            }
            if (data.organization_id) {
              this.getOrganizations();
            }
            if (data.quarter_id && data.district_id) {
              this.getQuarters()
            }
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    this.getRegions();
    this.getBoards();
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getKindergarden()
    }
  }
}
</script>

<template>
  <div class="accept-initiative">
    <div class="header">
      <p>Tashabbusni tasdiqlash</p>
    </div>
    <div class="form" v-loading="loading">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
          <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="top"
              style="width: 100%"
              status-icon
          >
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Boardni tanlang" prop="board_id">
                  <el-select size="large"
                             v-model="form.board_id"
                             placeholder="Boardni tanlang"
                             clearable
                             style="width: 100%">
                    <el-option
                        v-for="board in boards"
                        :key="board.id"
                        :value="board.id"
                        :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Viloyat" prop="region_id">
                  <el-select
                      size="large"
                      v-model="region_id"
                      style="width: 100%"
                      @change="onChangeRegion"
                  >
                    <el-option
                        v-for="region in regions"
                        :key="region.id"
                        :value="region.id"
                        :label="region.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Tuman" prop="district_id">
                  <el-select
                      size="large"
                      v-model="district_id"
                      style="width: 100%"
                      @change="onChangeDistrict"
                  >
                    <el-option
                        v-for="district in districts"
                        :key="district.id"
                        :value="district.id"
                        :label="district.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Obyektning manzili" prop="quarter_id">
                  <el-select size="large" v-model="form.quarter_id" style="width: 100%">
                    <el-option
                        v-for="quarter in quarters"
                        :key="quarter.id"
                        :value="quarter.id"
                        :label="quarter.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item
                    label="Tashkilot nomi"
                    prop="organization_id"
                >
                  <el-select size="large" v-model="form.organization_id" style="width: 100%">
                    <el-option
                        v-for="item in organizationList"
                        :key="item.id"
                        :value="item.id"
                        :label="item.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Bajarilgan ish turi" prop="type_of_work">
                  <el-select
                      style="width: 100%"
                      size="large"
                      v-model="form.type_of_work"
                  >
                    <el-option
                        v-for="type in workTypes"
                        :key="type.value"
                        :value="type.value"
                        :label="type.label"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Lakatsiya" prop="location">
                  <el-input
                      size="large"
                      class="form-input"
                      v-model="form.location"
                      type="text"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Obyektning texnik holati" prop="technical_position">
                  <el-input
                      size="large"
                      class="form-input"
                      v-model="form.technical_position"
                      type="text"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Obyektning quvvati" prop="power">
                  <el-input-number
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      v-model="form.power"
                      type="number"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <el-form-item label="Dastlabki qiymat" prop="initial_value">
                  <el-input-number
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      v-model="form.initial_value"
                      type="number"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <el-form-item label="So'ngi ta'mir yili" prop="last_repaired_year">
                  <el-date-picker
                      size="large"
                      style="width: 100%"
                      v-model="form.last_repaired_year"
                      type="year"
                      format="YYYY"
                      value-format="YYYY"
                      clearable
                      placeholder="Yilni tanlang"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
                <el-form-item label="Loyiha mazmuni" prop="description">
                  <el-input
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      :rows="6"
                      v-model="form.description"
                      type="textarea"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-button id="upload_img" class="info-btn form-input" @click="handleImageUpload">
                  <input type="file" id="fileInputRef" @change="uploadImg" style="display: none"/>
                  <img src="@/assets/images/gallery.svg" alt="gallery" style="margin-right: 4px"/>
                  Obyekt fotosuratini yuklang
                </el-button>
              </el-col>
              <el-col :span="24">
                <div class="images">
                  <div class="image-item" v-for="(imageHash,index) in form.images" :key="imageHash">
                    <el-button round
                               @click="onClickRemove(index)"
                               class="custom-delete-btn"
                               type="danger">
                      X
                    </el-button>
                    <el-image style="margin:8px 0; border:1px solid #e4e4e4; border-radius: 4px;"
                              :src="baseUrl+imageHash"
                              fit="contain"/>
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga
                  </el-button
                  >
                  <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash
                  </el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped lang="scss">
.info-btn {
  margin: 10px 0;
  width: 100%;
}

.images {
  columns: 3;

  .image-item {
    position: relative;

    :deep(el-image) {
      border: 1px solid #e4e4e4;
    }

    .custom-delete-btn {
      position: absolute;
      z-index: 1;
      right: -12px;
      font-weight: bold;
      font-size: 11px;
    }
  }
}
</style>
